import { Component, Input } from '@angular/core';
import { ActionPlanItem } from '../../shared/models/index';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'action-plan-item-status',
    templateUrl: 'item-status.component.html',
    standalone: false
})
export class ActionPlanItemStatusComponent {
  public appRoute: string = environment.applicationRoute;
  public inspectionsRoute = `/${this.appRoute}/inspections`;
  public actionPlansRoute = `/${this.appRoute}/actionPlans`;

  @Input() public actionPlanItem: ActionPlanItem;

  public getEditRoute() {
    return [
      this.actionPlansRoute,
      this.actionPlanItem.actionPlanId,
      'actionPlanItem',
      this.actionPlanItem.id,
      'editstatus'
    ];
  }
}
